import { useQuery, useSuspenseQuery } from '@tanstack/react-query';

import { ConfigApiInstance } from '~src/main/api';
import { useSiteId } from '~src/main/hooks/useSiteId';

export function useBookingRuleQueryKey() {
  const siteId = useSiteId();

  const keys = {
    all: ['booking-rule', siteId] as const,
    lists: () => [...keys.all, 'list'] as const,
    list: () => [...keys.lists()] as const,
  };

  return keys;
}

export async function fetchBookingRuleList({ site_id }: { site_id: string | undefined }) {
  const { data } = await ConfigApiInstance.siteGet.configGetSite({ config_type: 'ONLY_ACTIVE', site_id });
  return data.site?.custom_booking_methods ?? [];
}

export function useBookingRuleListQuery() {
  const keys = useBookingRuleQueryKey();
  const siteId = useSiteId();

  return useQuery({
    queryFn: () => fetchBookingRuleList({ site_id: siteId }),
    queryKey: keys.list(),
  });
}

export function useBookingRuleListSuspenseQuery() {
  const keys = useBookingRuleQueryKey();
  const siteId = useSiteId();

  return useSuspenseQuery({
    queryFn: () => fetchBookingRuleList({ site_id: siteId }),
    queryKey: keys.list(),
  });
}
